<template>
	<Head title="Confirmação de Identidade"></Head>

	<div class="container">
		<div class="row align-items-center mt-10 mb-10 row-logo">
			<div class="col mx-auto text-center">
				<img
					alt="Logo Habilite-se"
					src="/habil/images/logo.svg"
					class="h-35px" />
			</div>
		</div>

		<div class="row align-items-center row-card">
			<div class="col-sm-10 col-md-10 col-lg-10 mx-auto text-center">
				<div class="card">
					<div class="card-body">
						<div class="text-center mb-10">
							<h2 class="m-0">Confirmação de Identidade</h2>
							<p style="font-size: 15px; color: #747a7e">
								Verifique se as informações estão corretas
							</p>
						</div>

						<div class="row mb-10">
							<div class="col-lg-4 mt-3">
								<img
									v-if="userAvatar"
									:src="userAvatar"
									class="h-150px w-150px rounded-circle" />
								<img
									v-else
									src="/images/img/user.png"
									class="h-150px w-150px rounded-circle" />
							</div>

							<div class="col-lg-8 mt-3">
								<div class="row mb-2">
									<div
										class="col-lg-4"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-600"
											>Nome Completo:
										</span>
									</div>
									<div class="col-8" style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-800"
											>{{ props.user.name }}</span
										>
									</div>
								</div>

								<div class="row mb-2">
									<div
										class="col-lg-4"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-600"
											>CPF:</span
										>
									</div>
									<div
										class="col-lg-8"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-800"
											>{{ props.user.cpf }}</span
										>
									</div>
								</div>

								<div class="row mb-2">
									<div
										class="col-lg-4"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-600"
											>Equipamento:</span
										>
									</div>
									<div
										class="col-lg-8"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-800"
											>{{
												props.computer.descricao
											}}</span
										>
									</div>
								</div>

								<div class="row mb-2">
									<div
										class="col-lg-4"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-600"
											>CFC:</span
										>
									</div>
									<div
										class="col-lg-8"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-800"
											>{{ props.subtenant.name }}</span
										>
									</div>
								</div>

								<div class="row mb-2">
									<div
										class="col-lg-4"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-600"
											>Data da prova:</span
										>
									</div>
									<div
										class="col-lg-8"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-800"
											>{{ props.dataProva }}</span
										>
									</div>
								</div>

								<div class="row mb-2">
									<div
										class="col-lg-4"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-600"
											>Horário marcado:</span
										>
									</div>
									<div
										class="col-lg-8"
										style="text-align: left">
										<span
											class="fw-bolder fs-3 text-gray-800"
											>{{ props.horaProva }}</span
										>
									</div>
								</div>
							</div>
						</div>

						<div class="text-center mt-3">
							<a
								id="go-out"
								class="btn btn-danger m-1"
								href="/logoutProva">
								Informações incorretas
							</a>

						<form
							v-if="props.spa_enabled"
							class="d-inline"
							@submit.prevent="submit">
							<button
								id="continue"
								class="btn btn-primary"
								:disabled="form.processing"
								type="submit">
								Continuar para instruções
							</button>
						</form>

						<form
							v-else
							class="d-inline"
							method="post"
							:action="props.submitUrl">
							<input
								type="hidden"
								name="_token"
								:value="props.csrfToken" />
							<button
								id="continue"
								class="btn btn-primary"
								type="submit">
								Continuar para instruções
							</button>
						</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { Head, useForm } from '@inertiajs/vue3';
	import { onMounted, ref } from 'vue';
	import { commonStore } from '../../stores/common';
	import { checkConnection } from '../../websockets/WebsocketVerification';

	const common = commonStore();

	const props = defineProps({
		user: { type: Object, required: true },
		computer: { type: Object, required: true },
		subtenant: { type: Object, required: true },
		userAvatar: { type: String, required: true },
		dataProva: { type: String, required: true },
		horaProva: { type: String, required: true },
		submitUrl: { type: String, required: true },
		csrfToken: { type: String, required: true },
		is_ws_verification: { type: Boolean, required: true },
		is_agent_support_ws_verification: { type: Boolean, required: true },
		computer_uid: { type: String, required: true },
		descricao_computer: { type: String, required: true },
		spa_enabled: { type: Boolean, required: false, default: false },
	});

	const form = useForm({
		_token: props.csrfToken,
	});

	function submit() {
		form.post(props.submitUrl);
	}

	const connectionSpinner = ref(true);
	const connectionStatus = ref({
		connection: false,
		verified: false,
	});

	onMounted(() => {
		common.startKeyUp();

		checkConnection(props, connectionStatus, connectionSpinner);

		setInterval(() => {
			checkConnection(props, connectionStatus, connectionSpinner);
		}, 25000);

	});
</script>

<style scoped></style>
